import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { OverflowStrip } from '../OverflowStrip';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import { SearchParamEnum } from '../../constants';
import NewFiltersList from './components/NewFiltersList';
import { ignoredFilters } from './constants';
import type { NewFilterSummaryProps } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

const NewFilterSummary = ({
  totalLabel,
  alwaysShowTitle = false,
  loadCompanyFilterList,
}: NewFilterSummaryProps) => {
  const [params] = useSearchParams();

  const filteredParams = Array.from(params.entries()).filter(
    ([key]) => !ignoredFilters.includes(key),
  );

  const filterCount = filteredParams.length;

  const hasSearchParam = useMemo(
    () => Boolean(params.get(SearchParamEnum.SEARCH)),
    [params],
  );

  const allFiltersCount = filterCount + (hasSearchParam ? 1 : 0);

  const hasFilters = allFiltersCount > 0;

  const hasMoreThanOneFilter = allFiltersCount > 1;

  const filterTitle = hasMoreThanOneFilter
    ? 'Filtros aplicados:'
    : 'Filtro aplicado:';

  const getTitle = () => {
    if (totalLabel)
      return (
        <Typography component="div" variant="subtitle1">
          Total de{' '}
          <Typography
            variant="subtitle1"
            display="inline"
            color={NEW_COLORS.SEMANTICS.WARNING[500]}
          >
            {totalLabel}
          </Typography>
        </Typography>
      );

    return null;
  };

  return (
    <>
      {hasFilters && (
        <OverflowStrip>
          <Stack padding={3} gap={2}>
            {totalLabel && getTitle()}

            <Stack flexDirection="row" alignItems="center" gap={1}>
              <Typography variant="text">
                <b>{filterTitle}</b>
              </Typography>

              <NewFiltersList loadCompanyFilterList={loadCompanyFilterList} />
            </Stack>
          </Stack>
        </OverflowStrip>
      )}

      {!hasFilters && alwaysShowTitle && <Stack>{getTitle()}</Stack>}
    </>
  );
};

export default NewFilterSummary;
